module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dBslQ"))).then(() => parcelRequire('hEqeo'));